/**
 * How a member's name reads on a leaderboard: the name they go by, then their
 * last name. "Noah Crable", never just "Noah".
 *
 * Every board uses this one rule so the same person reads the same way in the
 * app and on the club's screens. Before, PinGolf let a preferred name stand in
 * for the whole name, which turned anyone whose preferred name was their first
 * name into a first name alone, and two people with the same first name into
 * the same row.
 *
 * Two exceptions, both to avoid saying something twice:
 * - A preferred name that is just their Stern handle is skipped for their first
 *   name, because boards show the handle on its own line.
 * - A preferred name that already has the last name in it is used as it is.
 *
 * Accepts the API's camelCase or snake_case fields, since boards get both.
 * Mirrored on the server in server/src/utils/personName.js. Keep them in step.
 */
export function personName(entry = {}) {
  const clean = (value) => String(value || '').trim();
  const first = clean(entry.firstName ?? entry.first_name);
  const last = clean(entry.lastName ?? entry.last_name);
  const preferred = clean(entry.preferredName ?? entry.preferred_name);
  const handle = clean(entry.sternUsername ?? entry.stern_username);

  const isHandle = preferred && handle && preferred.toLowerCase() === handle.toLowerCase();
  const given = (preferred && !isHandle ? preferred : first) || preferred;

  const words = given.toLowerCase().split(/[^\p{L}\p{N}'-]+/u);
  if (last && words.includes(last.toLowerCase())) return given;

  return [given, last].filter(Boolean).join(' ');
}

export default personName;
